import { spawn } from 'redux-saga/effects';

import userSaga from 'store/user/saga';

export default function* rootSaga() {
    yield spawn(userSaga);
}